import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {LoginModalComponent} from '@app/login-modal.component';

@Injectable()
export class UtilityService {

  constructor() {}

  private _barBackground: BehaviorSubject<string> = new BehaviorSubject<string>('f5ce0f');
  private _barTextColor: BehaviorSubject<string> = new BehaviorSubject<string>('000000');
  private _menuOpened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private modalRef: any;

  setBarBackground(color: string = null) {
    this._barBackground.next(color || 'f5ce0f');
  }

  getBarBackground(): Observable<{}> {
    const color = this._barBackground;
    return this.asObservable(color);
  }

  setBarTextColor(color: string = null) {
    this._barTextColor.next(color || '000000');
  }

  getBarTetColor(): Observable<{}> {
    return this.asObservable(this._barTextColor);
  }

  isMenuOpened(): Observable<{}> {
    return this.asBooleanObservable(this._menuOpened);
  }

  openLoginModal(modalService: NgbModal, redirectTo: string) {
    this.modalRef = modalService.open(LoginModalComponent,
      { windowClass: 'modal-centered modal-login' });
    this.modalRef.componentInstance.isModal = true;
    this.modalRef.componentInstance.redirectTo = redirectTo;
  }

  closeLoginModal() {
    this.modalRef.close();
  }

  toggleMenu() {
    this._menuOpened.next(!this._menuOpened.value);
  }

  asObservable(subject: Subject<string>) {
    return new Observable(fn => subject.subscribe(fn));
  }

  asBooleanObservable(subject: Subject<boolean>) {
    return new Observable(fn => subject.subscribe(fn));
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/utils.service.ts